<template>
    <div>
        <Banner :banners="banners" show-overlay class="white"> </Banner>
        <Breadcrumb></Breadcrumb>
        <div class="info-wrapper white">
            <h2 class="title text-center title-align">負碳拚拚看</h2>
            <div>
                <p class="carbon-text-sm subtitleWrapper">
                    恭喜你完成了碳足跡標籤的拼圖！<br>再多認識其他負碳商品有關的標章吧！
                </p>
            </div>
            <MarkLayout :markList="markList" />
            <div class="pagination">
                <span>1/2</span>
                <button @click.prevent="goView('/carbon/certificationMarkNext')">
                    &#10095;
                </button>
            </div>
        </div>
    </div>
</template>

<script>
/* eslint-disable global-require */
import Banner from '@/components/shared/Banner';
import Breadcrumb from '@/components/Breadcrumb';
import coreMixin from '@/js/mixin/coreMixin';
import MarkLayout from '@/components/markLayout';

export default {
    data() {
        return {
            banners: [
                {
                    linkUrl: require('@/assets/banner_guide.jpg'),
                },
            ],
            markList: [
                {
                    title: '碳足跡標籤',
                    imgUrl: require('@/assets/碳標籤圖示.jpg'),
                    imgWidth: 'width:120px',
                    content: '碳足跡標籤是一種碳排放量之標示方式，其涵義是指一個產品從原料取得、製造、配送、使用到最後廢棄回收等階段所產生的溫室氣體，換算成二氧化碳的總和。<br>透過碳標籤制度的施行，能使產品碳排放來源透明化，促使企業調整其產品碳排放量較大的製程，也能促使消費者正確地使用產品，以達減低產品碳排放量的效益。<br>碳足跡標籤以愛大自然的「心」結合代表健康、自然的「綠葉」組成，在心型上須標示「碳足跡」數字與計量單位。',
                },
                {
                    title: '省水標章',
                    imgUrl: require('@/assets/省水標章NEW.jpg'),
                    imgWidth: 'width:240px',
                    content: '經濟部水利署為鼓勵消費者選用省水產品，，推動省水標章制度。符合產品規格之產品即頒發省水標章使用證書，消費者認明省水標章選購合格省水器材，即能在不影響原用水習慣下，達到節約用水之目的。<br>標章設計以箭頭向上，代表將中心的水滴接起，強調回歸再利用，提高用水效率；右邊三條水帶，代表「愛水、親水、節水」，藉以鼓勵民眾愛護水資源，親近河川、湖泊、水庫，並共同推動節約用水。',
                },
            ],
        };
    },
    components: {
        Banner,
        Breadcrumb,
        MarkLayout,
    },
    methods: {
        goView(link) {
            this.$router.push(link).catch(() => { });
        },
    },
    mixins: [coreMixin],
};
</script>

<style lang="sass" scoped>
.selectStyle
    width: 100%
.subtitleWrapper
    padding: 12px 0
.pagination
    display: flex
    justify-content: center
    align-items: center
    padding: 24px 0
    span
        padding: 0 24px
        font-weight: 700
        font-size: 14px
    button
        border: none
        background-color: transparent
        color: #ccc
</style>
